import { render, staticRenderFns } from "./AdminBaseComponent.vue?vue&type=template&id=1b81995f&scoped=true&"
import script from "./AdminBaseComponent.vue?vue&type=script&lang=js&"
export * from "./AdminBaseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81995f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b81995f')) {
      api.createRecord('1b81995f', component.options)
    } else {
      api.reload('1b81995f', component.options)
    }
    module.hot.accept("./AdminBaseComponent.vue?vue&type=template&id=1b81995f&scoped=true&", function () {
      api.rerender('1b81995f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/AdminBaseComponent.vue"
export default component.exports